import permissionUser from '@/inheritance/permission-user';

export default {
  /**
   * Nombre del componente
   */
  name: 'IssueAlerts',

  extends: permissionUser,
  /**
   * Props de entrada
   */
  props: {
    data: {
      type: Object,
      required: true
    },
    alertType: {
      type: String,
      required: true,
      validator: value => ['warning', 'danger', 'success'].includes(value)
    },
    message: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods:  {
    iconClass() {
      if (this.icon) {
        return `fal fa-${this.icon} mr-2`;
      }
      switch (this.alertType) {
        case 'danger':
          return 'fal fa-clock mr-2';
        case 'warning':
          return 'fal fa-exclamation-triangle mr-2';
        case 'success':
          return 'fal fa-check-circle mr-2';
        default:
          return '';
      }
    }
  },
}
